import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';

// Containers
import Full from './containers/Full/';

// Views
import PrivacyPolicyApp from './views/Pages/PrivacyPolicyApp/';

ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route
        exact
        path="/privacy-policy-apps"
        name="CNDY Wallet Privacy Policy"
        component={PrivacyPolicyApp}
      />
      <Route path="/" name="Home" component={Full} />
    </Switch>
  </HashRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js